export const CAL_EVENT_GRACE_HOURS = { default: 48, max: 168 };
//# sourceMappingURL=cal-event-grace-hours.js.map